import { createClient } from "@supabase/supabase-js";
import { makeStorage } from "./cookieStorage";
import { resolveAuthDomain } from "./resolveAuthDomain";

const SUPABASE_URL = "https://boyobkfnektoaooclnso.supabase.co";
const SUPABASE_ANON_KEY = "sb_publishable_aOurGAFr7tKJqBsd4j2TAw_xMxUl0ux";

const rootDomain =
  typeof window !== "undefined"
    ? resolveAuthDomain(window.location.hostname)
    : "";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: makeStorage({ rootDomain }),
    // Bypass navigator.locks to prevent deadlocks when supabase.from() is
    // called inside onAuthStateChange callbacks
    lock: (_name, _acquireTimeout, fn) => fn(),
  },
});

export { resolveAuthDomain } from "./resolveAuthDomain";
